var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.046,
    height: 15.134,
    viewBox: "0 0 14.046 15.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "support",
    transform: "translate(-1.49 -0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M15.4,7.409a.548.548,0,0,1-.548-.548V5.312a4.256,4.256,0,0,0-4.518-3.948A4.271,4.271,0,0,0,5.817,5.312V6.861a.548.548,0,0,1-1.1,0V5.312A5.369,5.369,0,0,1,10.335.25,5.369,5.369,0,0,1,15.95,5.312V6.861a.544.544,0,0,1-.548.548Z",
    transform: "translate(-1.813)",
    fill: "#3b57a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M12.106,20.286a.548.548,0,0,1-.548-.548V14.531A.548.548,0,0,1,12.106,14a3.307,3.307,0,0,1,3.43,3.154A3.289,3.289,0,0,1,12.106,20.286Zm.548-5.15v4a2.132,2.132,0,0,0,1.781-2,2.132,2.132,0,0,0-1.781-2ZM4.92,20.286a3.3,3.3,0,0,1-3.43-3.15A3.293,3.293,0,0,1,4.92,14a.548.548,0,0,1,.548.548v5.189A.548.548,0,0,1,4.92,20.286Zm-.548-5.15a2.132,2.132,0,0,0-1.781,2,2.132,2.132,0,0,0,1.781,2Z",
    transform: "translate(0 -7.718)",
    fill: "#3b57a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M22.254,28.617H20.438a.548.548,0,0,1,0-1.1h1.816a1.07,1.07,0,0,0,1.07-1.07v-.241a.548.548,0,0,1,1.1,0v.241a2.167,2.167,0,0,1-2.167,2.167Z",
    transform: "translate(-10.329 -14.263)",
    fill: "#3b57a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M15.694,30.838H14.61a1.5,1.5,0,0,1-1.5-1.5v-.061a1.5,1.5,0,0,1,1.5-1.5h1.084a1.5,1.5,0,0,1,1.5,1.5v.061a1.5,1.5,0,0,1-1.5,1.5Zm-1.075-1.961a.4.4,0,0,0-.4.4v.061a.4.4,0,0,0,.4.4h1.075a.4.4,0,0,0,.4-.4v-.061a.4.4,0,0,0-.4-.4Z",
    transform: "translate(-6.523 -15.453)",
    fill: "#3b57a9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.91148c47cc832dff022ac5030b0b99d2.svg";
export { ForwardRef as ReactComponent };